/**
 * Format a report timestamp for display (e.g. "12/27/2025 at 9:01 AM").
 * Returns null for missing/unparseable input.
 *
 * Split out from `CriticalResultBanner.tsx` so the component module only
 * exports components (keeps React Fast Refresh happy).
 */
export function formatReportTimestamp(isoString: string | null | undefined): string | null {
  if (!isoString) return null
  try {
    const d = new Date(isoString)
    if (Number.isNaN(d.getTime())) return null
    const date = d.toLocaleDateString('en-US', { month: 'numeric', day: 'numeric', year: 'numeric' })
    const time = d.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true })
    return `${date} at ${time}`
  } catch {
    return null
  }
}
